import React, { useEffect, useRef, useState } from "react";

// Animated count-up that triggers when scrolled into view.
// Handles values like "7+", "3,000+", "100%", "24/7".
const parseInit = (value) => {
  const m = String(value).match(/^([^\d]*)([\d,]+)(.*)$/);
  return m ? `${m[1]}0${m[3]}` : String(value);
};

const CountUp = ({ value, duration = 1500, className = "" }) => {
  const ref = useRef(null);
  const done = useRef(false);
  const [disp, setDisp] = useState(() => parseInit(value));

  useEffect(() => {
    const m = String(value).match(/^([^\d]*)([\d,]+)(.*)$/);
    if (!m) { setDisp(String(value)); return; }
    const prefix = m[1] || "";
    const hasComma = m[2].includes(",");
    const target = parseInt(m[2].replace(/,/g, ""), 10);
    const suffix = m[3] || "";
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !done.current) {
          done.current = true;
          const start = performance.now();
          const tick = (now) => {
            const p = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            const cur = Math.round(eased * target);
            const s = hasComma ? cur.toLocaleString() : String(cur);
            setDisp(prefix + s + suffix);
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [value, duration]);

  return <span ref={ref} className={className}>{disp}</span>;
};

export default CountUp;
